import {
  Burger,
  CustomNavLinkSmall,
  HeaderSection,
  Label,
  LogoContainer,
  Menu,
  NotHidden,
  Outline,
  Span,
} from "./styles";
import { Drawer, Row } from "antd";

import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { TFunction } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useState } from "react";

interface HeaderProps {
  t?: TFunction;
  showNav: boolean;
}

const Header = ({ t, showNav }: HeaderProps) => {
  const [visible, setVisibility] = useState(false);
  const history = useHistory(); // Move history hook to component level

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    const scrollTo = (id: string) => {
      const element = document.getElementById(id) as HTMLDivElement;
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      setVisibility(false);
    };
    
    return (
      <>
        {showNav ? (
          <>
            {/* Home page navigation - full navbar with all sections */}
            <CustomNavLinkSmall onClick={() => {
              history.push("/about");
              setVisibility(false);
            }}>
              <Span>About Us</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => {
              history.push("/partnerships");
              setVisibility(false);
            }}>
              <Span>Partnerships</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => {
              history.push("/careers");
              setVisibility(false);
            }}>
              <Span>Careers</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => {
              history.push("/challenges");
              setVisibility(false);
            }}>
              <Span>Challenges</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => scrollTo("impact")}>
              <Span>Impacts</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => scrollTo("contact")}>
              <Span>Contact</Span>
            </CustomNavLinkSmall>
          </>
        ) : (
          <>
            {/* Navigation for other pages - go to dedicated pages */}
            <CustomNavLinkSmall onClick={() => {
              history.push("/about");
              setVisibility(false);
            }}>
              <Span>About Us</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => {
              history.push("/partnerships");
              setVisibility(false);
            }}>
              <Span>Partnerships</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => {
              history.push("/careers");
              setVisibility(false);
            }}>
              <Span>Careers</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => {
              history.push("/challenges");
              setVisibility(false);
            }}>
              <Span>Challenges</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => {
              history.push("/");
              setVisibility(false);
            }}>
              <Span>← Home</Span>
            </CustomNavLinkSmall>
          </>
        )}
      </>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between" align="middle">
          <LogoContainer to="/" aria-label="Myy Venture Capital - Home">
            <SvgIcon src="venture.png" alt="Myy Venture Capital" width="101px" height="64px" />
          </LogoContainer>
          
          <NotHidden>
            <MenuItem />
          </NotHidden>
          
          <Burger onClick={toggleButton} role="button" aria-label="Toggle navigation menu">
            <Outline />
          </Burger>
        </Row>
        
        <Drawer 
          placement="right"
          closable={false} 
          open={visible} 
          onClose={toggleButton}
          width={320}
          bodyStyle={{
            padding: "var(--space-6)",
            backgroundColor: "var(--gray-50)",
          }}
        >
          <Label onClick={toggleButton}>
            <Menu>Menu</Menu>
            <Outline />
          </Label>
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default Header;
